module.exports = __webpack_public_path__ + "img/netProfitBlue.e3fea7e1.png";